module.exports = __webpack_public_path__ + "static/media/cash.8a7cd567.png";